import { useState } from "react";
import type { Resource } from "../types";

interface DetailResourcesProps {
  resources: Resource[];
  resourceTypeLabel?: string;
}

const DEFAULT_SHOWN = 3;

const chipStyle: React.CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: 7,
  padding: "6px 11px",
  borderRadius: 8,
  background: "#F2F4F7",
  border: "1px solid #E4E7EC",
  color: "#101828",
  fontSize: 13,
  fontWeight: 500,
};

// Resource chips for the detail page. Matches the "Discover (A)" chip styling.
// Chips are static: the resource hyperlink (click-to-redirect) and the tooltip
// are intentionally disabled — they render as plain, non-interactive chips and
// collapse past 3 with More/Less.
export const DetailResources = ({ resources, resourceTypeLabel }: DetailResourcesProps) => {
  const [expanded, setExpanded] = useState(false);

  const shown = expanded ? resources : resources.slice(0, DEFAULT_SHOWN);

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
      {shown.map((r, i) => (
        <span key={`${r.resource_uri}-${i}`} style={chipStyle}>
          {r.resource_name}
          {i === 0 && resourceTypeLabel && (
            <span
              style={{
                fontSize: 10,
                color: "#667085",
                textTransform: "uppercase",
                letterSpacing: "0.04em",
                fontWeight: 600,
              }}
            >
              {resourceTypeLabel}
            </span>
          )}
        </span>
      ))}
      {resources.length > DEFAULT_SHOWN && (
        <button
          type="button"
          onClick={() => setExpanded(e => !e)}
          style={{
            border: "none",
            background: "none",
            color: "#247EFE",
            fontSize: 13,
            fontWeight: 600,
            cursor: "pointer",
            padding: "6px 4px",
          }}
        >
          {expanded ? "Less" : `+${resources.length - DEFAULT_SHOWN} more`}
        </button>
      )}
    </div>
  );
};
